import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllExternalNote = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/extern/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const createExternalNote = async (payload, context) => {

  // // Ajout du fichier
  // formData.append('pieceJustificatif', payload.pieceJustificatif);

  const response = await axios.post(
    apiPaths.baseUrl + `/api/extern/create`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        // "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateExternalNote = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/extern/update/${id}`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        // "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const getExternalNoteById = async (id, context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/extern/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const deleteExternalNote = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/extern/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getExternalNoteByStudent = async (id_studentProfil, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/extern/getStudent/${id_studentProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// export const updateParent = async (id,payload) => {
//   const response = await axios.put(
//     apiPaths.baseUrl + `/api/parent/updateParent/${id}`,
//     payload,
//     { headers: setHeaders(context),  }
//   );
//   return response.data;
// };

// export const modifyParentPassword = async () => {
//   const response = await axios.put(
//     apiPaths.baseUrl + `/api/parent/modifyPassword`,
//     { headers: setHeaders(context),  }
//   );
//   return response.data;
// };

// --------------------------Import/Export-------------------------------------------------------

export const importParentProfil = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importParent`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
